const features = [
  {
    icon: 'ri-search-eye-line',
    title: 'Ricerca più veloce',
    description: 'Trova prodotti organizzati senza perdere tempo grazie alle tabelle strutturate e alle categorie ben definite.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Confronto semplice',
    description: 'Analizza diverse categorie e confronta prezzi, qualità e caratteristiche dei prodotti in un unico posto.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Maggiore controllo',
    description: 'Valuta le informazioni con attenzione prima di prendere decisioni grazie a dati aggiornati e foto reali.',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            Perché utilizzare <span className="italic">Itaobuy Spreadsheet</span>?
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Tre buoni motivi per integrare questo strumento nel tuo processo di ricerca prodotti
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group bg-white rounded-2xl border border-background-200/70 p-6 md:p-8 hover:border-primary-200 transition-all cursor-default"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-white transition-all">
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-xl font-bold text-foreground-900 mb-3">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}